import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import InsertChartOutlinedOutlinedIcon from '@material-ui/icons/InsertChartOutlinedOutlined';
import CancelScheduleSendOutlinedIcon from '@material-ui/icons/CancelScheduleSendOutlined';
import WebOutlinedIcon from '@material-ui/icons/Web';

import {
    User as UserIcon,
    PieChart as PieChartIcon,
    Users as UsersIcon,
    Shield as ShieldIcon
} from 'react-feather';
import SyncIcon from '@material-ui/icons/Sync';
const AdminNavConfig = [
    {
        canview: ['admin', 'root'],
        subheader: 'Main',
        items: [
            {
                title: 'Dashboard',
                icon: PieChartIcon,
                href: '/admin/dashboard'
            }
        ]
    },
    {
        canview: ['admin', 'root'],
        subheader: 'Manage',
        items: [
            {
                title: 'Users',
                icon: UsersIcon,
                href: '/admin/users'
            },
            {
                title: 'Web requests',
                icon: ReceiptIcon,
                href: '/admin/requests'
            },
            {
                title: 'Attachment Audit',
                icon: ShieldIcon,
                href: '/admin/audit'
            }
        ]
    },
    {
        canview: ['admin', 'root'],
        subheader: 'Reports',
        items: [
            {
                title: 'Summary',
                icon: WebOutlinedIcon,
                href: '/manager/reports/summary'
            },
            {
                title: 'Quotes',
                icon: InsertChartOutlinedOutlinedIcon,
                href: '/manager/reports/quotes'
            },
            {
                title: 'Cancellations',
                icon: CancelScheduleSendOutlinedIcon,
                href: '/manager/reports/cancellations'
            }
        ]
    },
    {
        canview: ['admin', 'root'],
        subheader: 'Settings',
        href: '/app/pages',
        items: [
            {
                title: 'Account',
                href: '/account',
                icon: UserIcon
            },
            {
                title: 'Configuration',
                href: '/admin/settings',
                icon: SettingsOutlinedIcon
            },
            {
                title: 'Portal Sync',
                href: '/admin/sync',
                icon: SyncIcon
            }
        ]
    }
];

export default AdminNavConfig;
